<template>
	<div>
		<div class="content-panel color-scheme-dark login-area" v-if="!isLoged">
			<login />
		</div>
		<div v-if="token">
			<iframe class="iframe" :src="'https://embed.tombalaklas.com/?token='+token+'&origin=https://'+api+'/'"></iframe>
		</div>
	</div>
</template>

<script>
	import login from '@/components/auth/Login'

    export default {
        name: 'tombola',
        components: {login},
          data () {
              return {
                  api: window.api,
                  isLoged: true,
                  token: null,
                  session: window.session
              }
          },
	    mounted (){
			  this.createToken()
	    },
	    methods: {
            createToken () {
                this.$http.get(api+'api/v1/tombola/create/user', ).then(
                    response => {

                        this.token = response.body.token;
                        this.isLoged = true;

                }, response => {
                        this.isLoged = false;
                });
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.login-area {
		padding-top: 140px;
		min-height: 900px;
		background-image: url(http://www.spelbingo.se/wp-content/uploads/2013/06/kvinna-spelar-bingo-p%C3%A5-n%C3%A4tet.png);
		background-repeat: no-repeat;
		background-position: top;
	}

	.tbg {
		background: url(/static/assets/img/tbg.jpg) no-repeat;
		background-size: cover;
	}
	.iframe {
		width: 100%;
		height: 100vh;
		border: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/casino/tombola.vue